/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken } from '@nebular/auth';
import { DataTablesModule } from 'angular-datatables';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
    NbToastrModule,
    NbWindowModule,

} from '@nebular/theme';
import { AuthGuard } from './guards/auth-guard.service';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { XmlDownloadComponent } from './pages/xml-download/xml-download.component';
import { XmlDownloadPComponent } from './pages/xml-download-p/xml-download-p.component';
import { SafePipe } from './safe.pipe';
import { XmlDettaglioDocComponent } from './pages/xml-dettaglio-doc/xml-dettaglio-doc.component';
import { DataService } from './services/data.service';
import { AuthInterceptor } from './interceptor/auth-interceptor';
import { ErrorInterceptor } from './interceptor/error-interceptor';
import { LoginOComponent } from './pages/login_o/login.component';
import { AuthGuardO } from './guards/auth-guard-o.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoutComponent } from './pages/login_o/logout.component';

registerLocaleData(localeIt);

@NgModule({
    declarations: [AppComponent, XmlDownloadComponent, XmlDownloadPComponent, XmlDettaglioDocComponent,
        LoginOComponent, LogoutComponent],
    exports: [], // <---
    imports: [
    BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
      HttpClientModule,
        AppRoutingModule,
        DataTablesModule,
      NbDateFnsDateModule.forRoot({ format: 'yyyy-MM-dd' }),
      NbDateFnsDateModule.forRoot({ format: 'yyyy-MM-dd' }),
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
        CoreModule.forRoot(),
        //NbAuthModule.forRoot({
        //    strategies: [
        //        NbPasswordAuthStrategy.setup({
        //            name: 'email',
        //            baseEndpoint: 'https://g.geniosoft.vip',
        //            login: {
        //                endpoint: '/users/loginFatturazione',
        //                method: 'post',
        //                requireValidToken: false,
        //                redirect: {
        //                    success: '/pages/doc-attivi/elenco', 
        //                    failure: null, // stay on the same page
        //                },
        //                defaultErrors: ['Credenziali non corrette. Riprova'],
        //                defaultMessages: ['Accesso avvenuto correttamente.'],
        //            },
        //            logout: {
        //                alwaysFail: false,
        //                endpoint: '/users/logout',
        //                method: 'delete',
        //                redirect: {
        //                    success: '/',
        //                    failure: null,
        //                },
        //                defaultErrors: ['Si è verificato un errore'],
        //                defaultMessages: ['Logout in corso...'],
        //            },

        //            token: {
        //                class: NbAuthJWTToken,
        //                key: 'token', // this parameter tells where to look for the token
        //            }
        //        }),

        //    ],
        //    forms: {

        //        logout: {
        //            redirectDelay: 2500,
        //        },
        //        login: {
        //            redirectDelay: 2500,
        //        },
        //    },
        //}),
  ],
    bootstrap: [AppComponent],

    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'IT' },
        AuthGuardO,
        DataService
    ]
})
export class AppModule {
}
